import { isAndroid, isIOS } from "react-device-detect";

export function saveVCardAndroid(item) {
  // vCard verilerini oluştur
  const vCardData = `
BEGIN:VCARD
VERSION:3.0
FN:${item.name + " " + item.surname}
N:${item.surname + ";" + item.name + ";;;"}
ORG:${item.organization}
TEL:${item.phone}
TEL; type = WORK; type = pref: ${item.companyPhone || item.phone}
URL;type = WORK; type = pref: ${item.link}
URL;type = Linkedin; type = pref:${item.linkedinUrl}
EMAIL:${item.email}
EMAIL; type = INTERNET; type = WORK; type = pref: ${
    item.companyEmail || item.email
  }
ADR;TYPE=WORK:${
    item.street +
    ";" +
    item.city +
    "; " +
    item.county +
    "; " +
    item.postCode +
    ";" +
    item.country
  }
END:VCARD
`;

  // vCard verilerini içeren Blob'u oluştur
  const blob = new Blob([vCardData], { type: "text/vcard" });

  // Blob'u içeren URL oluştur
  const url = window.URL.createObjectURL(blob);

  // a elementi oluştur ve indirme bağlantısını ayarla
  const link = document.createElement("a");
  link.href = url;
  link.download = item.name + ".vcf";
  link.textContent = item.name;

  // a elementini sayfaya ekleyin ve otomatik olarak tıklayın
  document.body.appendChild(link);
  link.click();

  // a elementini sayfadan kaldırın
  document.body.removeChild(link);

  // URL'yi serbest bırakın
  window.URL.revokeObjectURL(url);
}

export const saveVCard = (item) => {
  const vcard = [
    "BEGIN:VCARD",
    "VERSION: 3.0",
    "FN:" + item.name + " " + item.surname,
    "N:" + item.surname + ";" + item.name + ";;;",
    "ORG:" + item.organization,
    "TITLE:" + item.title,
    "EMAIL:" + item.email,
    item.companyEmail
      ? "EMAIL; type = INTERNET; type = WORK; type = pref:" + item.companyEmail
      : "0",
    item.companyPhone
      ? "TEL; type = WORK; type = pref:" + item.companyPhone
      : "",
    "TEL;TYPE=CELL:" + item.phone,
    "URL;type = WORK; type = pref:" + item.link,
    "URL;type = Linkedin; type = pref:" + item.linkedinUrl,
    "item1.ADR; type = WORK: ;; " +
      item.street +
      ";" +
      item.city +
      "; " +
      item.county +
      "; " +
      item.postCode +
      ";" +
      item.country,
    "NOTE:" + `${item.note || "There is no note"}`,
    "END: VCARD",
  ].join("\r\n");

  var blob = new Blob([vcard], {
    type: "text/vcard",
  });
  var url = URL.createObjectURL(blob);

  const newLink = document.createElement("a");
  newLink.download = item.name + ".vcf";
  newLink.textContent = item.name;
  newLink.href = url;
  newLink.setAttribute("download", item.name + ".vcf"); // Download özelliği ekleniyor

  newLink.click();
};
